export default "__VITE_ASSET__1ec73c6f__"